import { AbstractModel } from "./abstract-model";
import { Rotina } from "./eacesso-rotina";
import { Classificacao } from "./registro-produto";

export class LimberChefProduto extends AbstractModel {
    nomeProduto: string = "";
    codigo: string = "";
    acessos: string[] = [];
    acessosComDescricao?: Rotina[];
    classificacao: Classificacao;
}


export class LimberChefRegistroLicenca {
    expDate: Date = new Date();
    nroLicencas: number = 1;
    acessoGeral: boolean = false;
    acessos: string[] = [];
    empresas: LimberChefRegistroLicencaEmpresa[] = [];
    ip?: string;
    naoSincronizarEntidadesHabil: boolean = false;
}

export class LimberChefRegistroLicencaEmpresa {
    documento: string = "";
    nome: string = "";
    vcto: Date = new Date();
    licencas: number = 0;
}